import React from 'react';
import { Wallet } from 'lucide-react';

const AccountEquityCard = ({ metrics }) => {
  if (!metrics) return null;

  const { current_equity, starting_balance, total_return } = metrics;
  const isPositive = total_return >= 0;
  const pnl = current_equity - starting_balance;

  return (
    <div className="bg-card text-card-foreground rounded-lg shadow-sm border border-border p-4 md:p-5">
      <div className="flex items-center gap-2 mb-3">
        <div className="p-1.5 rounded-lg bg-primary/10">
          <Wallet className="w-4 h-4 text-primary" />
        </div>
        <h3 className="text-sm font-semibold text-foreground">Account Equity</h3>
      </div>

      <div className="space-y-3">
        <div>
          <p className={`text-2xl font-bold font-mono tabular-nums tracking-tight ${
            isPositive ? 'text-green-500' : 'text-red-500'
          }`}>
            ${current_equity.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </p>
        </div>

        <div className="flex items-center justify-between text-xs">
          <span className="text-muted-foreground">Starting Balance</span>
          <span className="font-medium text-foreground font-mono tabular-nums">
            ${starting_balance.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </span>
        </div>

        <div className="flex items-center justify-between text-xs">
          <span className="text-muted-foreground">Total P&L</span>
          <span className={`font-medium font-mono tabular-nums ${isPositive ? 'text-green-500' : 'text-red-500'}`}>
            {isPositive ? '+' : ''}${pnl.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </span>
        </div>

        <div className="flex items-center justify-between text-xs">
          <span className="text-muted-foreground">Total Return</span>
          <span className={`font-semibold px-1.5 py-0.5 rounded text-xs ${
            isPositive ? 'bg-green-500/10 text-green-500' : 'bg-red-500/10 text-red-500'
          }`}>
            {isPositive ? '+' : ''}{total_return.toFixed(2)}%
          </span>
        </div>
      </div>
    </div>
  );
};

export default AccountEquityCard;
